var map = {
	"./a-day-in-the-country-and-other-stories-08-24-2024.json": 562,
	"./a-farewell-to-arms-06-26-2023.json": 723,
	"./a-tidewater-morning-04-13-2024.json": 8942,
	"./absalom-absalom-11-24-2024.json": 6758,
	"./alice-munro-selected-stories-1968-1994-06-26-2023.json": 6880,
	"./babylon-revisited-and-other-stories-07-07-2025.json": 7311,
	"./black-spring-06-26-2023.json": 7440,
	"./brighton-rock-12-11-2023.json": 1560,
	"./chilly-scenes-of-winter-10-30-2024.json": 7907,
	"./dubliners--02-21-2023.json": 3878,
	"./enormous-changes-at-the-last-minute-05-27-2024.json": 1670,
	"./ethan-frome--02-20-2023.json": 7058,
	"./fathers-and-sons-06-26-2023.json": 6765,
	"./first-love-last-rites-05-27-2024.json": 1401,
	"./greasy-lake-08-29-2026.json": 4817,
	"./i-cannot-tell-a-lie-exactly-02-14-2025.json": 9025,
	"./jude-the-obscure-09-19-2025.json": 5143,
	"./knights-gambit-06-26-2023.json": 6878,
	"./lost-in-the-city-02-01-2025.json": 5768,
	"./loving-•-living-•-party-going-02-10-2026.json": 2044,
	"./miramar-11-21-2023.json": 6924,
	"./nightmare-town-01-15-2025.json": 9038,
	"./nobodys-angel-03-27-2025.json": 4874,
	"./nothing-•-doting-•-blindness-06-25-2025.json": 1989,
	"./of-mice-and-men-06-26-2023.json": 8489,
	"./open-city-06-26-2023.json": 5028,
	"./out-of-this-world-06-11-2025.json": 1174,
	"./paris-review-243-06-26-2023.json": 8875,
	"./paris-stories-07-15-2024.json": 5137,
	"./rabbit-run-07-15-2024.json": 6705,
	"./red-harvest-03-03-2025.json": 2991,
	"./sense-and-sensibility-08-18-2025.json": 6348,
	"./sons-and-lovers-02-17-2025.json": 4003,
	"./summer-03-07-2025.json": 5772,
	"./tenth-of-december-01-20-2024.json": 6807,
	"./the-big-sleep-04-18-2025.json": 2864,
	"./the-brothers-karamazov-11-14-2023.json": 5791,
	"./the-chekhov-omnibus-selected-stories-01-19-2024.json": 2623,
	"./the-day-of-the-owl-03-04-2025.json": 4964,
	"./the-dew-breaker-06-26-2023.json": 9671,
	"./the-end-of-the-affair-09-07-2023.json": 2169,
	"./the-heart-of-the-matter-06-26-2023.json": 813,
	"./the-house-of-mirth-06-26-2023.json": 6671,
	"./the-lady-in-the-lake-•-the-little-sister-•-the-long-goodbye-•-playback-11-24-2025.json": 3740,
	"./the-new-york-trilogy-10-14-2025.json": 4588,
	"./the-old-forest-and-other-stories-06-13-2026.json": 4442,
	"./the-old-man-and-the-sea-11-09-2023.json": 2849,
	"./the-penguin-book-of-modern-british-short-stories-06-26-2023.json": 1488,
	"./the-power-and-the-glory--02-26-2023.json": 8039,
	"./the-prime-of-miss-jean-brodie-12-05-2023.json": 3669,
	"./the-scarlet-letter-02-25-2024.json": 9513,
	"./the-stranger--11-12-2022.json": 1179,
	"./the-sun-also-rises-06-26-2023.json": 3480,
	"./the-things-they-carried-01-20-2024.json": 5155,
	"./the-vets-daughter-05-27-2024.json": 8871,
	"./the-waves-04-25-2023.json": 9371,
	"./the-woodlanders-03-17-2024.json": 8828,
	"./thomas-hardy-the-withered-arm-and-other-stories--01-04-2023.json": 8095,
	"./to-the-north-06-26-2026.json": 5417,
	"./train-dreams-08-04-2024.json": 7373,
	"./twenty-one-stories-01-19-2024.json": 1779,
	"./two-nurses-smoking-01-19-2024.json": 4301,
	"./warlight-10-04-2024.json": 8618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9647;